import * as _fs2 from "fs";
var _fs = "default" in _fs2 ? _fs2.default : _fs2;
import * as _vm2 from "vm";
var _vm = "default" in _vm2 ? _vm2.default : _vm2;
import * as _module2 from "module";
var _module = "default" in _module2 ? _module2.default : _module2;
import * as _process2 from "process";
var _process = "default" in _process2 ? _process2.default : _process2;
var exports = {};
var module = {
  exports: exports
};
var process = _process;
const {
    readFileSync,
    writeFileSync
  } = _fs,
  {
    Script
  } = _vm,
  {
    wrap
  } = _module;
const basename = new URL(import.meta.url.slice(0, import.meta.url.lastIndexOf("/"))).pathname + "/index.js";
const source = readFileSync(basename + ".cache.js", "utf-8");
const cachedData = !process.pkg && _process.platform !== "win32" && readFileSync(basename + ".cache");
const scriptOpts = {
  filename: basename + ".cache.js",
  columnOffset: -62
};
const script = new Script(wrap(source), cachedData ? Object.assign({
  cachedData
}, scriptOpts) : scriptOpts);
script.runInThisContext()(exports, null, module, new URL(import.meta.url).pathname, new URL(import.meta.url.slice(0, import.meta.url.lastIndexOf("/"))).pathname);
if (cachedData) process.on("exit", () => {
  try {
    writeFileSync(basename + ".cache", script.createCachedData());
  } catch (e) {}
});
export default module.exports;